var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#4D5B68",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-loader",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 22
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 7.76,
    y2: 7.76
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 16.24,
    x2: 19.07,
    y2: 19.07
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 6,
    y2: 12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 22,
    y2: 12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 19.07,
    x2: 7.76,
    y2: 16.24
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 7.76,
    x2: 19.07,
    y2: 4.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ffbcd3022b7c52bfea9667388987b66d.svg";
export { ForwardRef as ReactComponent };